import loading from '../images/loading.gif'
import guy from '../images/pins/blue_guy.png'
import house from '../images/pins/blue_house.png'
import warning from '../images/pins/brown_exclamation.png'
import returnTo from '../images/pins/brown_return.png'
import lookup from '../images/pins/cyan_magn_glass.png'
import plus from '../images/pins/green_plus.png'
import minus from '../images/pins/orange_minus.png'
import star from '../images/pins/pink_star.png'
import heart from '../images/pins/red_heart.png'
import check from '../images/pins/yellow_check.png'

export const collectionneurAssets = {
  pinIcons: {
    guy,
    house,
    warning,
    return_to: returnTo,
    lookup,
    plus,
    minus,
    star,
    heart,
    check,
  },
  loading,
}
